module.exports = __webpack_public_path__ + "media/img/pages/profile/bund ger 10-bc327d40051c7504e0d8c5dc8432cd80.jpg";